import { createRootRoute, Outlet } from '@tanstack/react-router';
import { z } from 'zod';
import { useOrgPortal } from '@hooks/useOrgPortal.ts';
import ProductDetailModal from '@features/product-detail/ProductDetailModal.tsx';
import { isNotNullOrUndefined } from '@utils/utils.tsx';
import { AuthBridge } from '@security/auth/AuthBridge.tsx';

const modalSearchSchema = z.object({
  productId: z.number().int().positive().optional(),
  selectedTab: z.enum(['detail', 'alternatives']).optional(),
});

export const Route = createRootRoute({
  validateSearch: modalSearchSchema,
  component: RootComponent,
  beforeLoad: ctx => {
    if (Object.keys(ctx.params).includes('orgId') && Object.keys(ctx.params).includes('portalId')) {
      useOrgPortal.getState().setOrgPortal(parseInt((ctx.params as { orgId: string }).orgId), parseInt((ctx.params as { portalId: string }).portalId));
    }
  },
});

function RootComponent() {
  const search = Route.useSearch();

  return (
    <AuthBridge>
      <Outlet />
      {isNotNullOrUndefined(search.productId) && (
        <ProductDetailModal productId={search.productId} selectedTab={search.selectedTab || 'detail'} visible={isNotNullOrUndefined(search.productId)} />
      )}
    </AuthBridge>
  );
}
